import { useState } from 'react'

import { formatMobile } from '../../../helpers/formatters'
import { User } from '../../../models/user'
import { ProfileCard, ProfileCardItem } from './ProfileCard'
import { ProfileEmergencyContactEdit } from './ProfileEmergencyContactEdit'

interface ProfileEmergencyContactProps {
  user: User
  canEdit: boolean
}

export function ProfileEmergencyContact({ user, canEdit }: ProfileEmergencyContactProps) {
  const [editEmergencyContact, setEditEmergencyContact] = useState(false)
  const emergencyContact = user.driver?.emergencyContact

  return (
    <>
      <ProfileCard
        title="Emergency contact"
        onEdit={canEdit ? () => setEditEmergencyContact(true) : undefined}
      >
        <ProfileCardItem label="Name">{emergencyContact?.name || '-'}</ProfileCardItem>
        <ProfileCardItem label="Relationship">{emergencyContact?.relationship || '-'}</ProfileCardItem>
        <ProfileCardItem label="Email">{emergencyContact?.email || '-'}</ProfileCardItem>
        <ProfileCardItem label="Phone">{formatMobile(emergencyContact?.mobile || '') || '-'}</ProfileCardItem>
      </ProfileCard>

      {editEmergencyContact && (
        <ProfileEmergencyContactEdit user={user} handleClose={() => setEditEmergencyContact(false)} />
      )}
    </>
  )
}
